import styled from '@emotion/styled'
import { Checkbox } from 'antd'
import { Days } from 'components/Common/types'

export const SelectDays = styled.div`
  display: flex;
  gap: 24px;
  justify-content: space-between;
`

export const DayPillCheckbox = styled(Checkbox, {
  shouldForwardProp: (prop) => prop !== 'day'
})<{ day: Days }>`
  &.ant-checkbox-wrapper {
    position: relative;

    width: 36px;
    height: 36px;
    background-color: #f3f2f4;
    border-radius: 100%;
  }

  &:hover {
    background-color: #f0f1fd;
    color: #4a4a68;
  }

  &.ant-checkbox-wrapper-checked {
    background-color: #4a4a68;
  }

  &.ant-checkbox-wrapper::after {
    position: absolute;
    inset: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    content: ${({ day }) => `'${day[0].toUpperCase()}'`};
    width: 100%;
    height: 100%;

    color: #5b5a5e;
    font-size: 12px;
    line-height: 14.06px;
    font-weight: 500;
    letter-spacing: -0.02em;
  }

  &.ant-checkbox-wrapper-checked::after {
    color: #ffffff;
  }

  .ant-checkbox {
    opacity: 0;
  }

  &.ant-checkbox-wrapper-disabled {
    opacity: 0.25;
  }
`
